export class Thanks {
  title?: string;
  text?: string;
  border?: boolean
  constructor(data: Thanks) {
    this.title = data.title;
    this.text = data.text;
    this.border = data.border;
  }
}

